import Link from 'next/link';
import dayjs from 'dayjs';
import { onlyDateTimeFormat } from 'constants/global';
import { withCDN } from 'helpers/cdn';
import Image from 'ui3/Image/Image';
import styles from './ArticleByline.module.scss';

export type ArticleAuthor = {
  slug: string;
  name: string;
  avatarURL?: string | null;
};

type ArticleBylineProps = {
  author: ArticleAuthor | null;
  publishedAt: string | null | undefined;
  readingMinutes: number;
};

// The visible byline names the same author as the Article structured data.
const ArticleByline = ({
  author,
  publishedAt,
  readingMinutes,
}: ArticleBylineProps): JSX.Element => {
  const published = publishedAt ? dayjs(publishedAt) : null;

  return (
    <div className={styles.root}>
      {author ? (
        <Link href={`/${author.slug}`} prefetch={false}>
          <a className={styles.author} rel="author">
            <span className={styles.avatar}>
              <Image
                src={
                  author.avatarURL ||
                  withCDN('/images/icons/avatar-placeholder.svg')
                }
                alt=""
                sizes="36px"
              />
            </span>
            <span className={styles.name}>By {author.name}</span>
          </a>
        </Link>
      ) : (
        <span className={styles.author}>
          <span className={styles.avatar}>
            <Image
              src={withCDN('/images/logos/mobile-logo-white.svg')}
              alt="MILLIONS logo"
              unoptimized
            />
          </span>
          <span className={styles.name}>MILLIONS</span>
        </span>
      )}
      <span className={styles.meta}>
        {published?.isValid() && (
          <time dateTime={published.toISOString()}>
            {published.format(onlyDateTimeFormat)}
          </time>
        )}
        <span className={styles.readingTime}>{readingMinutes} min read</span>
      </span>
    </div>
  );
};

export default ArticleByline;
